import { render, staticRenderFns } from "./TestadorRegra.vue?vue&type=template&id=0726dfa8&scoped=true"
import script from "./TestadorRegra.vue?vue&type=script&lang=js"
export * from "./TestadorRegra.vue?vue&type=script&lang=js"
import style0 from "./TestadorRegra.vue?vue&type=style&index=0&id=0726dfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0726dfa8",
  null
  
)

export default component.exports